import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor( private http: HttpClient,
    private apiService: ApiService) { }

  changePassword(body: any): Observable<any>{
    return this.apiService.post(`UserProfiles/PostChangePassword`, body)
  }
  newUserChangePassword(body: any): Observable<any>{
    return this.apiService.post(`UserProfiles/NewUserChangePassword`, body)
  }
  public updateFirstLoginAttempt(UserName:string): Observable<any> {
    return this.apiService.get(`UserProfiles/UpdateFirstLoginAttempt/${UserName}`);
   }
}
